module.exports = __webpack_public_path__ + "img/paymentSuccess.d904310f.svg";